import {
  COLORS,
  FONT_SIZES,
  Icon,
  mediaDesktopAndUp,
  mediaLargeScreens,
} from '@aboutyou/ui-components';
import {css} from '@linaria/core';
import {styled} from '@linaria/react';
import {HEADER_DEFAULT_PADDING, SEARCH_BAR_WIDTH} from '../constants';

export const Wrapper = styled.div<{isSearchBarExpanded: boolean}>`
  width: 100%;
  max-width: ${props =>
    props.isSearchBarExpanded ? 'unset' : `${SEARCH_BAR_WIDTH}px`};
`;

export const StyledSearchIcon = styled(Icon)`
  cursor: pointer;
  margin: 0 8px;
`;

export const StyledInput = styled.input`
  width: 100%;
  background: ${COLORS.Grey4};
  font-size: ${FONT_SIZES.px12};

  @media ${mediaDesktopAndUp} {
    padding-top: 2px;
    width: calc(100% - 36px);
  }

  &:placeholder-shown {
    text-overflow: ellipsis;
  }
`;

export const StyledCloseIcon = styled(Icon)`
  margin-right: 4px;
  cursor: pointer;
`;

export const SearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 9px;
  right: ${HEADER_DEFAULT_PADDING.tablet}px;
  border-radius: 4px;
`;

export const SearchBarWrapperTablet = css`
  @media ${mediaDesktopAndUp} {
    right: 28px;
  }
  @media ${mediaLargeScreens} {
    right: ${HEADER_DEFAULT_PADDING.largeScreens}px;
  }
`;
